import useTranslate from '@hooks/useTranslate';
import { closeModal } from '@stores/modals';

import { DatePicker, Form, Modal } from 'antd';
import { FunctionComponent } from 'react';
import modalContent from '../UserInfo.content.json';
import { useForm } from 'antd/lib/form/Form';
import moment, { Moment } from 'moment';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import IUser from '@interfaces/IUser';
import { useParams } from 'react-router';
import { addPlus, getIsPlus, getItem } from '@stores/user';
// eslint-disable-next-line no-duplicate-imports
interface AddPlusValue {
  startDate: Date;
  endDate: Date;
  accountId: IUser['id'];
  date: [Moment, Moment];
}
dayjs.extend(customParseFormat);

const UserAddPlusModal: FunctionComponent = () => {
  const { userId } = useParams<{ userId: IUser['id'] }>();
  const content = useTranslate(modalContent);
  const [form] = useForm();
  const onFinish = async (values: AddPlusValue) => {
    const dataRequest = {
      startDate: moment(values.date[0]).format(),
      endDate: moment(values.date[1]).format(),
      accountId: userId,
    };
    await addPlus(dataRequest);
    await closeModal({ name: 'plus' });
    await getItem({ userId: userId }).then(() => getIsPlus({ userId }));
  };

  const disabledDate = (current: Moment) => {
    return current && current < dayjs().endOf('day');
  };

  return (
    <Modal
      title={content.gameramPlusActive}
      visible
      onCancel={() => closeModal({ name: 'plus' })}
      onOk={() => form.submit()}
    >
      <Form
        onFinish={onFinish}
        form={form}
      >
        <Form.Item
          name='date'
          style={{ padding: 0, margin: 0 }}
        >
          <DatePicker.RangePicker
            disabledDate={disabledDate}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserAddPlusModal;
